/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createMetaAdStructureDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	campaignName: z.string(),
	campaignId: z.string().uuid(),
	campaignStartDate: z.string(),
	campaignEndDate: z.string(),
	advertiseOnFacebook: z.boolean(),
	advertiseOnInstagram: z.boolean(),
	adMessage: z.string().nullable().optional(),
	adLink: z.string().url().nullable().optional(),
	adCaption: z.string().nullable().optional(),
	adPicture: z.string().url().nullable().optional(),
	storyPicture: z.string().url().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	targetingOptions: z.object({
		cities: z.array(
			z.object({
				id: z.string(),
				name: z.string(),
				radius: z.number(),
				region: z.object({ id: z.string(), name: z.string() }).nullable(),
				country: z.object({ id: z.string(), name: z.string() }).nullable(),
			}),
		).optional(),
		countries: z.array(z.object({ id: z.string(), name: z.string() })).optional(),
		interests: z.array(z.object({ id: z.string(), name: z.string(), path: z.array(z.string()).nullable() }))
			.optional(),
	}),
})

export type CreateMetaAdStructureDataSchema = z.infer<typeof createMetaAdStructureDataSchema>
